import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
	return (
		<div className="App">
			<ToastContainer />
			<AppRoutes />
		</div>
	);
};

export default App;
